import { render, staticRenderFns } from "./host-set-comNat.vue?vue&type=template&id=31c14a21&scoped=true&"
import script from "./host-set-comNat.vue?vue&type=script&lang=js&"
export * from "./host-set-comNat.vue?vue&type=script&lang=js&"
import style0 from "./host-set-comNat.vue?vue&type=style&index=0&id=31c14a21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c14a21",
  null
  
)

export default component.exports